import {Theme} from "@mui/material";
import {nunitoBase, palette} from "../../technical/style/theme";

export const wideFormFieldStyles = (theme: Theme) => ({
  container: {
    marginBottom: theme.spacing(1.5)
  },
  labelContainer: {
    alignSelf: 'center',
    marginRight: theme.spacing(1),
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    color: "black",
    ...palette.lightGreyTextOpacity,
    textTransform: "uppercase",
  },
  value: {
    fontWeight: 600,
    color: "black",
    ...palette.greyTextOpacity,
    ...nunitoBase,
  }
});
